import * as types from 'constants/actionTypes';

export const dashboardFail = (error) => {
    return { type: types.DASHBOARD_FAIL, error };
}

export const getOrders = (branchId, refreshCache = false) => {
    return { type: types.GET_ORDERS, branchId, refreshCache };
}

export const dbGotOrders = (orders) => {
    return { type: types.DB_ORDERS_GOT, orders };
}

export const getCashDrawer = (branchId, refreshCache = false) => {

    return { type: types.GET_CASHDRAWER, branchId, refreshCache };
}

export const dbCashDrawerGot = (cashDrawers) => {
    return { type: types.DB_CASHDRAWER_GOT, cashDrawers };
}

export const getSales = (model, refreshCache = false) => {
    return { type: types.GET_SALES, model, refreshCache };
}

export const dbGotSales = (sales) => {
    return { type: types.DB_SALES_GOT, sales };
}

export const getTopProductsSales = (model, refreshCache = false) => {
    return { type: types.GET_TOP_PRODUCTS_SALES, model, refreshCache };
}

export const dbGotTopProductsSales = (productsSales) => {
    return { type: types.DB_TOP_PRODUCTS_SALES_GOT, productsSales };
}

export const getTopMembers = () => {
    return { type: types.GET_TOP_MEMBERS };
}

export const dbGotTopMembers = (topMembers) => {
    return { type: types.DB_TOP_MEMBERS_GOT, topMembers };
}

export const getTopSellers = (model, refreshCache = false) => {
    return { type: types.GET_TOP_SELLERS, model, refreshCache };
}

export const dbGotTopSellers = (topSellers) => {
    return { type: types.DB_TOP_SELLERS_GOT, topSellers }
}

export const getTimesheet = (branchId, refreshCache = false) => {
    return { type: types.GET_TIMESHEET, branchId, refreshCache }
}

export const dbGotTimesheet = (timesheet) => {
    return { type: types.DB_TIMESHEET_GOT, timesheet }
}

export const getPurchaseOrdersDb = (branchId, refreshCache = false) => {
    return { type: types.GET_PURCHASE_ORDER, branchId, refreshCache }
}

export const dbGotPurchaseOrders = (purchaseOrders) => {
    return { type: types.DB_PURCHASE_ORDER_GOT, purchaseOrders };
}

export const getInvetory = (model, refreshCache = false) => {
    return { type: types.GET_INVENTORY, model, refreshCache };
}

export const dbGotInvetory = (invetory) => {
    return { type: types.DB_INVENTORY_GOT, invetory };
}

export const getCampaignDb = (branchId, refreshCache = false) => {
    return { type: types.GET_CAMPAIGN, branchId, refreshCache };
}

export const dbGotCampaign = (campaigns) => {
    return { type: types.DB_CAMPAIGN_GOT, campaigns };
}

export const RemoveCache = () => {
    return { type: types.REMOVE_CACHE };
}
